// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pgm-lists-containers {
  overflow: hidden;
}
.pgm-lists-containers .pgmlist_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.pgm-lists-containers .pgmlistmain {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.pgm-lists-containers .pgmlistmain::-webkit-scrollbar {
  width: 0px;
}
.pgm-lists-containers .pgmlistmain::-webkit-scrollbar-thumb {
  background: transparent;
}
.pgm-lists-containers .Pgmlist_pending {
  width: 15%;
  height: 40px;
  left: 299px;
  top: 122px;
  background: #0C3688;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  border: none;
  color: #FFFFFF;
}
.pgm-lists-containers .pgmlist_Approved {
  width: 15%;
  height: 40px;
  background: #E5F0FF;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7C87A1;
  border: none;
}
.pgm-lists-containers .pgmlist_Add {
  width: 15%;
  height: 40px;
  background: #E5F0FF;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7C87A1;
  border: none;
}
.pgm-lists-containers .input-wrapper {
  position: relative;
}
.pgm-lists-containers input {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.5rem;
  margin: 10px;
  line-height: 6ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
}
.pgm-lists-containers .display-count {
  padding: 10px 0px;
  display: flex;
  justify-content: center;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  color: white !important;
  width: 100%;
  margin: 10px auto;
}
.pgm-lists-containers label {
  position: absolute;
  top: 0px !important;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  color: #0c3688;
}
.pgm-lists-containers .select-wrapper {
  position: relative;
  display: block;
}
.pgm-lists-containers select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
}
.pgm-lists-containers ::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
}
.pgm-lists-containers .pgmlistdropdown_textfield {
  display: flex;
  justify-content: space-between;
  width: 96%;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  margin: 1rem;
  padding: 0.6rem;
}
.pgm-lists-containers .tablesth {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  color: white;
  text-align: left;
  padding: 14px 7px;
  background-color: #f5f5f5;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  background: #0c3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px -2px 0px 0px;
  font-family: "Nunito";
}
.pgm-lists-containers .tabletd-name,
.pgm-lists-containers .tabletd-shop-name,
.pgm-lists-containers .tabletd-location,
.pgm-lists-containers .tabletd-status {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 150px;
}
.pgm-lists-containers .tabletd_view {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  text-align: left;
  padding: 22px 5px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  border-top: 0.5px solid #999797;
  cursor: pointer;
}
.pgm-lists-containers .pagination_div {
  width: 98%;
  margin: auto;
  margin-bottom: 5rem;
}
.pgm-lists-containers .footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.pgm-lists-containers .header_border {
  background: #C0C8DA;
  height: 2.4rem;
  border: 1px solid #C0C8DA;
}
.pgm-lists-containers .header_border > img {
  margin: 0.9rem 1rem;
}
.pgm-lists-containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.pgm-lists-containers .pgmlistdropdown_div {
  width: 100%;
}

.pgmlistmain .tabledata {
  width: 98% !important;
  margin: auto;
  margin-top: 10px;
}
.pgmlistmain .tabledata .desktop-view {
  display: block;
}
.pgmlistmain .tabledata .mobile-view {
  display: none;
}

@media (max-width: 768px) {
  .desktop-view {
    display: none !important;
  }
  .mobile-view {
    display: flex !important;
    flex-direction: column;
    gap: 15px;
  }
  .cards {
    width: 98%;
    margin: auto;
    background: #dde7f5;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .cards .card-header {
    border-bottom: 1px solid #ddd;
    padding-bottom: 8px;
  }
  .cards .card-header h3 {
    font-size: 16px;
    margin: 0;
  }
  .cards .card-header .mobile-badge {
    background: #0C3688;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
  }
  .cards .card-body p {
    margin: 5px 0;
    font-size: 14px;
  }
  .cards .view-btn {
    width: 100%;
    margin-top: 10px;
    padding: 8px;
    background: #0C3688;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  .cards .view-btn:hover {
    background: #0C3688;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PgmList/pgmlist.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AACJ;AAEE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAUA,qBAAA;AATJ;AACI;EACE,UAAA;AACN;AAEI;EACE,uBAAA;AAAN;AAME;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAJJ;AAOE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AALJ;AAQE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AANJ;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AATJ;AAYE;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;AAVJ;AAaE;EACE,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AAXJ;AAcE;EACE,kBAAA;EACA,cAAA;AAZJ;AAeE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAbJ;AAgBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;EACA,+BAAA;EACA,qBAAA;AAhBJ;AAmBE;;;;EAIA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAjBF;AAoBE;EACE,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;AAlBJ;AAsBE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AArBJ;AAwBE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAtBJ;AAyBE;EACE,mBAAA;AAvBJ;AA0BE;EAEE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,WAAA;AA1BJ;;AAgCE;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;AA7BJ;AA+BI;EACE,cAAA;AA7BN;AAgCI;EACE,aAAA;AA9BN;;AAqCA;EACE;IACE,wBAAA;EAlCF;EAqCA;IACE,wBAAA;IACA,sBAAA;IACA,SAAA;EAnCF;EAsCA;IACE,UAAA;IACA,YAAA;IACA,mBAAA;IACA,aAAA;IACA,kBAAA;IACA,wCAAA;EApCF;EAsCE;IACE,6BAAA;IACA,mBAAA;EApCJ;EAsCI;IACE,eAAA;IACA,SAAA;EApCN;EAuCI;IACE,mBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,eAAA;EArCN;EA0CI;IACE,aAAA;IACA,eAAA;EAxCN;EA4CE;IACE,WAAA;IACA,gBAAA;IACA,YAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,eAAA;EA1CJ;EA4CI;IACE,mBAAA;EA1CN;AACF","sourcesContent":[".pgm-lists-containers {\n  overflow: hidden;\n\n  .pgmlist_container {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n  }\n\n  .pgmlistmain {\n    width: 100%;\n    background: #ffffff;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: calc(100vh - 66px);\n\n    &::-webkit-scrollbar {\n      width: 0px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: transparent;\n    }\n\n    scrollbar-width: none;\n  }\n\n  .Pgmlist_pending {\n    width: 15%;\n    height: 40px;\n    left: 299px;\n    top: 122px;\n    background: #0C3688;\n    border-radius: 8px 8px 0px 0px;\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 15px;\n    border: none;\n    color: #FFFFFF;\n  }\n\n  .pgmlist_Approved {\n    width: 15%;\n    height: 40px;\n    background: #E5F0FF;\n    border-radius: 8px 8px 0px 0px;\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    color: #7C87A1;\n    border: none;\n  }\n\n  .pgmlist_Add {\n    width: 15%;\n    height: 40px;\n    background: #E5F0FF;\n    border-radius: 8px 8px 0px 0px;\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    color: #7C87A1;\n    border: none;\n\n  }\n\n  .input-wrapper {\n    position: relative;\n  }\n\n  input {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    width: 92%;\n    height: 2.5rem;\n    margin: 10px;\n    line-height: 6ex;\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132E;\n    padding: 0rem 0.5rem;\n  }\n\n  .display-count {\n    padding: 10px 0px;\n    display: flex;\n    justify-content: center;\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    color: white !important;\n    width: 100%;\n    margin: 10px auto;\n  }\n\n  label {\n    position: absolute;\n    top: 0px !important;\n    z-index: 1;\n    left: 2em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px !important;\n    color: #0c3688;\n  }\n\n  .select-wrapper {\n    position: relative;\n    display: block;\n  }\n\n  select {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    margin: 10px;\n    line-height: 6ex;\n    width: 94%;\n    height: 2.5rem;\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132E;\n    padding: 0rem 0.5rem;\n  }\n\n  ::placeholder {\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132E;\n    padding: 0rem 0.5rem;\n  }\n\n  .pgmlistdropdown_textfield {\n    display: flex;\n    justify-content: space-between;\n    width: 96%;\n    background: #ffffff;\n    border: 1px solid #c1c6d0;\n    border-radius: 6px;\n    background: #ffffff;\n    border: 1px solid #c1c6d0;\n    border-radius: 6px;\n    margin: 1rem;\n    padding: 0.6rem;\n  }\n\n  .tablesth {\n    overflow: hidden;\n    word-break: break-all;\n    text-overflow: ellipsis;\n    color: white;\n    text-align: left;\n    padding: 14px 7px;\n    background-color: #f5f5f5;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    background: #0c3688;\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px -2px 0px 0px;\n    font-family: \"Nunito\";\n  }\n\n  .tabletd-name,\n.tabletd-shop-name,\n.tabletd-location,\n.tabletd-status {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;  \n  max-width: 150px; \n}\n\n  .tabletd_view {\n    overflow: hidden;\n    word-break: break-all;\n    text-overflow: ellipsis;\n    text-align: left;\n    padding: 22px 5px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0c3688;\n    border-top: 0.5px solid #999797;\n    cursor: pointer;\n\n  }\n\n  .pagination_div {\n    width: 98%;\n    margin: auto;\n    margin-bottom: 5rem;\n  }\n\n  .footer_div {\n    margin-top: 1rem;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n  }\n\n  .header_border {\n    background: #C0C8DA;\n    height: 2.4rem;\n    border: 1px solid #C0C8DA;\n  }\n\n  .header_border>img {\n    margin: 0.9rem 1rem;\n  }\n\n  .header_border>span {\n\n    font-family: 'Nunito';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    letter-spacing: -0.28px;\n    margin: 0.7rem 1rem;\n  }\n\n  .pgmlistdropdown_div {\n    width: 100%;\n  }\n\n}\n\n.pgmlistmain{\n  .tabledata {\n    width: 98% !important;\n    margin: auto;\n    margin-top: 10px;\n  \n    .desktop-view {\n      display: block;\n    }\n  \n    .mobile-view {\n      display: none;\n    }\n  }\n}\n\n\n\n@media (max-width: 768px) {\n  .desktop-view {\n    display: none !important;\n  }\n\n  .mobile-view {\n    display: flex !important;\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .cards {\n    width: 98%;\n    margin: auto;\n    background: #dde7f5;\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    .card-header {\n      border-bottom: 1px solid #ddd;\n      padding-bottom: 8px;\n\n      h3 {\n        font-size: 16px;\n        margin: 0;\n      }\n\n      .mobile-badge {\n        background: #0C3688;\n        color: #fff;\n        padding: 5px 10px;\n        border-radius: 5px;\n        font-size: 12px;\n      }\n    }\n\n    .card-body {\n      p {\n        margin: 5px 0;\n        font-size: 14px;\n      }\n    }\n\n    .view-btn {\n      width: 100%;\n      margin-top: 10px;\n      padding: 8px;\n      background: #0C3688;\n      color: #fff;\n      border: none;\n      border-radius: 5px;\n      cursor: pointer;\n      font-size: 14px;\n\n      &:hover {\n        background: #0C3688;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
